"use client";

import { useState } from "react";

export function PasswordInput() {
  const [show, setShow] = useState(false);

  return (
    <div className="relative">
      <input
        type={show ? "text" : "password"}
        name="password"
        placeholder="Site password"
        autoFocus
        required
        className="w-full border border-silver/30 rounded px-4 py-3.5 pr-16 text-base text-chocolate placeholder-silver/60 focus:outline-none focus:border-turquoise transition-colors bg-white appearance-none"
      />
      <button
        type="button"
        onClick={() => setShow(!show)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-silver/60 hover:text-chocolate active:text-chocolate transition-colors select-none px-1 py-1"
      >
        {show ? "Hide" : "Show"}
      </button>
    </div>
  );
}
